import React, { useState } from 'react'
import {
  Container,
  Box,
  Typography,
  Paper,
  Tabs,
  Tab,
  Button
} from '@mui/material'
import {
  Add,
  List as ListIcon,
  Pending,
  CheckCircle
} from '@mui/icons-material'
import RequestList from '../components/mrd/Requests/RequestList'
import RequestForm from '../components/mrd/Requests/RequestForm'
import RequestDetail from '../components/mrd/Requests/RequestDetail'

export const RequestsPage = () => {
  const [tabValue, setTabValue] = useState(0)
  const [refreshKey, setRefreshKey] = useState(0)
  const [openForm, setOpenForm] = useState(false)
  const [openDetail, setOpenDetail] = useState(false)
  const [selectedRequest, setSelectedRequest] = useState(null)
  const [selectedRequestId, setSelectedRequestId] = useState(null)

  const handleNewRequest = () => {
    setSelectedRequest(null)
    setOpenForm(true)
  }

  const handleEditRequest = (request) => {
    setSelectedRequest(request)
    setOpenForm(true)
    setOpenDetail(false)
  }

  const handleViewRequest = (request) => {
    setSelectedRequestId(request._id)
    setOpenDetail(true)
  }

  const handleFormClose = () => {
    setOpenForm(false)
    setSelectedRequest(null)
  }

  const handleDetailClose = () => {
    setOpenDetail(false)
    setSelectedRequestId(null)
  }

  const handleFormSuccess = () => {
    setOpenForm(false)
    setSelectedRequest(null)
    setRefreshKey(prev => prev + 1) // Refresh the list
  }

  const handleRefresh = () => {
    setRefreshKey(prev => prev + 1)
  }

  return (
    <Container maxWidth="xl">
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h4" fontWeight={600} gutterBottom>
            File Requests
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Manage MRD file requests and approvals
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={handleNewRequest}
        >
          New Request
        </Button>
      </Box>

      <Paper sx={{ mb: 3 }}>
        <Tabs value={tabValue} onChange={(e, val) => setTabValue(val)}>
          <Tab 
            label="All Requests" 
            icon={<ListIcon />}
            iconPosition="start"
          />
          <Tab 
            label="Pending" 
            icon={<Pending />}
            iconPosition="start"
          />
          <Tab 
            label="Approved" 
            icon={<CheckCircle />}
            iconPosition="start"
          />
        </Tabs>
      </Paper>

      {tabValue === 0 && (
        <Paper sx={{ p: 3 }}>
          <RequestList 
            key={refreshKey}
            onEdit={handleEditRequest}
            onView={handleViewRequest}
            onRefresh={handleRefresh}
          />
        </Paper>
      )}

      {tabValue === 1 && (
        <Paper sx={{ p: 3 }}>
          <RequestList 
            key={`pending-${refreshKey}`}
            statusFilter="PENDING"
            onEdit={handleEditRequest}
            onView={handleViewRequest}
            onRefresh={handleRefresh}
          />
        </Paper>
      )}

      {tabValue === 2 && (
        <Paper sx={{ p: 3 }}>
          <RequestList 
            key={`approved-${refreshKey}`}
            statusFilter="APPROVED"
            onEdit={handleEditRequest}
            onView={handleViewRequest}
            onRefresh={handleRefresh}
          />
        </Paper>
      )}

      {/* Request Form Dialog */}
      <RequestForm
        open={openForm}
        onClose={handleFormClose}
        request={selectedRequest}
        onSuccess={handleFormSuccess}
      />

      {/* Request Detail Dialog */}
      <RequestDetail
        open={openDetail}
        onClose={handleDetailClose}
        requestId={selectedRequestId}
        onEdit={handleEditRequest}
        onRefresh={handleRefresh}
      />
    </Container>
  )
}

